///////////////////////////////////////////////////
//dl-common.js
///////////////////////////////////////////////////
window.addEventListener("load", function () {
  DL_addClass(document.body, "is-load");
});
let GuideFlg = false;
window.addEventListener("keydown", function (e) {
  if (e.keyCode == 71) {
    //g
    toggleGuide();
  }
});
function toggleGuide() {
  if (GuideFlg) {
    GuideFlg = false;
    DL_removeClass(document.body, "is-guide");
  } else {
    GuideFlg = true;
    DL_addClass(document.body, "is-guide");
  }
}
// ************************************** セクションプログレス
class DL_ProgressSection {
  constructor(element) {
    this.element = element;
    // console.log(element)
    this.event();
    this.update();
  }
  event() {
    window.addEventListener("scroll", this.onScroll.bind(this));
    // if (media() === "PC" || window.afterWidth !== window.innerWidth) {
    window.addEventListener("resize", this.onResize.bind(this));
    // }
  }
  update() {
    this.rect = this.element.getBoundingClientRect();
    this.top = this.element.offsetTop;
    this.height = this.element.offsetHeight;
    this.topHeight = this.top + this.height;
    this.element.style.setProperty("--height", this.height + "px");
    this.onScroll();
  }
  onScroll() {
    this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    this.check();
  }
  onResize() {
    onWidthResize(({ width, height }) => {
      this.update();
    });
  }
  check() {
    DL_removeClass(this.element, ["is-start", "is-half", "is-end"]);
    if (this.top > this.scroll) {
      this.progress = 0;
    } else if (this.scroll > this.topHeight) {
      this.progress = 1;
    } else {
      DL_addClass(this.element, "is-start");
      this.progress = parseFloat(((this.scroll - this.top) / this.height).toFixed(3));
    }
    if (this.progress >= 0.5) {
      DL_addClass(this.element, "is-half");
    }
    if (this.progress == 1) {
      DL_addClass(this.element, "is-end");
    }

    this.element.style.setProperty("--progress", this.progress);
  }
}
if (document.querySelectorAll(".js-progressSection").length) {
  // new DL_ProgressSection(".js-progressSection");
  document.querySelectorAll(".js-progressSection").forEach((element) => {
    new DL_ProgressSection(element);
  });
}
// ************************************** セクションプログレス2(底辺から)
class DL_ProgressSection2 {
  constructor(element, opts = {}) {
    this.element = element;
    this.offset = opts.offset || 0; // 例: 固定ヘッダーの高さなどを補正したいとき
    this.event();
    this.update();
  }

  event() {
    window.addEventListener("scroll", this.onScroll.bind(this), { passive: true });
    window.addEventListener("resize", this.onResize.bind(this));
    // モバイルのアドレスバー変動対策
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", this.onResize.bind(this));
      window.visualViewport.addEventListener("scroll", this.onScroll.bind(this));
    }
  }

  update() {
    // ページ基準のY位置に正規化（親のpositionに影響されない）
    const rect = this.element.getBoundingClientRect();
    this.top = rect.top + window.scrollY;
    this.height = rect.height; // offsetHeightでもOKだがtransform考慮でrect.height推し
    this.topHeight = this.top + this.height;

    this.element.style.setProperty("--height", this.height + "px");
    this.onScroll();
  }

  onScroll() {
    // スクロール位置（ページ上端基準）
    this.scroll = window.scrollY || document.documentElement.scrollTop || 0;
    this.check();
  }

  onResize() {
    // サイズが変わるとtop/heightもズレるので再計算
    this.update();
  }

  check() {
    DL_removeClass(this.element, ["is-start", "is-half", "is-end"]);

    // ウィンドウ下端（visualViewport優先）＋任意オフセット
    const viewportH = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    const windowBottom = this.scroll + viewportH - this.offset;

    let progress;
    if (windowBottom <= this.top) {
      progress = 0;
    } else if (windowBottom >= this.topHeight) {
      progress = 1;
    } else {
      DL_addClass(this.element, "is-start");
      progress = (windowBottom - this.top) / this.height;
    }

    // 0〜1にクランプ＆小数3桁で丸め
    this.progress = Math.max(0, Math.min(1, Number(progress.toFixed(3))));

    if (this.progress >= 0.5) DL_addClass(this.element, "is-half");
    if (this.progress >= 1) DL_addClass(this.element, "is-end");

    this.element.style.setProperty("--progress", this.progress);
  }
}

if (document.querySelectorAll(".js-progressSection2").length) {
  document.querySelectorAll(".js-progressSection2").forEach((element) => {
    new DL_ProgressSection2(element, { offset: 0 });
  });
}

// ************************************** 画像遅延
class DL_LazyBgi {
  constructor(selector) {
    this.elements = document.querySelectorAll(selector);
    this.elements.forEach((element) => {
      element.src = element.getAttribute("data-bgi");
      element.style.backgroundImage = "url( " + element.src + " )";
    });
  }
}
new DL_LazyBgi(".dl-js-lazy_bgi");

// ************************************** スクロールアニメーション
class DL_ScrollAction {
  constructor(selector) {
    this.elements = document.querySelectorAll(selector);

    if (this.elements.length === 0) {
      return;
    } else {
      this.borderTop = 0;
      this.borderMiddle = 0.5;
      this.borderBottom = 0.8;
      this.flg = false;
      this.remove = true;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener("scroll", this.onScrollHandler, false);
      window.addEventListener("resize", this.onResize.bind(this));
      DL_removeClass(this.elements, "sa-active");
      this.init();
    }
  }
  init() {
    this.array = [];
    this.count = 0;
    this.windowTop = window.innerHeight * this.borderTop;
    this.windowMiddle = window.innerHeight * this.borderMiddle;
    this.windowBottom = window.innerHeight * this.borderBottom;
    this.elements.forEach((element) => {
      const sa = element;
      sa.top = DL_offsetTop(sa);
      sa.height = sa.offsetHeight;
      sa.topHeight = sa.top + sa.height;
      sa.bottom = sa.top + sa.height;
      sa.progress = 0;
      sa.flg = false;
      this.array.push(sa);
    });
    this.onScroll();
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.areaTop = Math.floor(scrollTop + this.windowTop);
    this.areaMiddle = Math.floor(scrollTop + this.windowMiddle);
    this.areaBottom = Math.floor(scrollTop + this.windowBottom);
    this.areaHeight = this.areaBottom - this.areaTop;
    this.areaHalf = this.areaBottom - this.areaMiddle;
    this.array.forEach((element) => {
      var sa = element;
      if (this.areaBottom >= sa.top && this.areaTop <= sa.bottom) {
        DL_addClass(sa, "sa-active");
        sa.progress = Math.round(((this.areaBottom - sa.top) / (this.areaHeight + sa.height)) * 100);
        sa.progressHalf = Math.round(((this.areaBottom - sa.top) / (this.areaHalf + sa.height / 2)) * 100);

        if (DL_hasClass(sa, "dl-js-sa__image")) {
          var scale = sa.getAttribute("data-scale");
          var range = scale * 100 - 100;
          sa.style.transform = "translate3d(0px, " + (range / 2 - range * (sa.progress / 100)) + "%, 0px) scale(" + scale + ")";
        }

        if (DL_hasClass(sa, "dl-js-sa__float")) {
          var rangeY = sa.getAttribute("data-rangeY");
          var rangeX = sa.getAttribute("data-rangeX");
          var adjust = Math.round(Math.cos((sa.progressHalf * Math.PI) / 180) * 100) / 100;
          var stop = JSON.parse(sa.getAttribute("data-stop").toLowerCase());
          if (stop) {
            sa.style.transform = "translate3d(" + Math.round(rangeX * Math.max(0, adjust) * 100) / 100 + "%, " + Math.round(rangeY * Math.max(0, adjust) * 100) / 100 + "%, 0px)";
          } else {
            sa.style.transform = "translate3d(" + Math.round(rangeX * adjust * 100) / 100 + "%, " + Math.round(rangeY * adjust * 100) / 100 + "%, 0px)";
          }
        }

        if (this.remove == false) {
          if (sa.flg == false) {
            sa.flg = true;
            this.count++;
            if (this.count == this.array.length) {
              this.flg = false;
            }
          }
        }
      } else {
        if (this.remove) {
          if (sa.getAttribute("data-remove")) {
            if (JSON.parse(sa.getAttribute("data-remove").toLowerCase())) {
              DL_removeClass(sa, "sa-active");
            }
          } else {
            DL_removeClass(sa, "sa-active");
          }
        }
      }
    });
  }
  onResize() {
    onWidthResize(({ width, height }) => {
      this.init();
    });
  }
}

// new DL_ScrollAction(".dl-js-sa");

class DL_ScrollActionImage {
  constructor(selector) {
    this.elements = document.querySelectorAll(selector);
    if (this.elements.length === 0) return;

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScrollHandler, false);
    window.addEventListener("resize", this.onResize.bind(this));
    this.init();
  }

  init() {
    this.array = [];
    this.elements.forEach((element) => {
      const sa = element;
      sa.top = DL_offsetTop(sa);
      sa.height = sa.offsetHeight;
      sa.bottom = sa.top + sa.height;
      sa.progress = 0;
      this.array.push(sa);
    });
    this.onScroll();
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowBottom = scrollTop + window.innerHeight;

    this.array.forEach((sa) => {
      let progress;

      if (windowBottom < sa.top) {
        // まだ画面下にあるとき
        progress = 0;
        DL_removeClass(sa, "saImage-active");
      } else if (scrollTop > sa.bottom) {
        // すでに上に見切れたとき
        progress = 1;
        DL_removeClass(sa, "saImage-active");
      } else {
        // 表示範囲内 → 0〜1 の値
        DL_addClass(sa, "saImage-active");
        let rawProgress = (windowBottom - sa.top) / (window.innerHeight + sa.height);
        progress = Math.min(Math.max(rawProgress, 0), 1);
      }

      sa.progress = parseFloat(progress.toFixed(3));
      sa.style.setProperty("--imageProgress", sa.progress);
    });
  }

  onResize() {
    onWidthResize(({ width, height }) => {
      this.init();
    });
  }
}

// 実行
// new DL_ScrollActionImage(".dl-js-saImage");

// --- 安定待ち関数 ---
function waitForStableLayout({ selectors = [".dl-js-sa", ".dl-js-saImage", ".splide"], consecutive = 8, timeout = 15000, eps = 0.5, immediateMargin = 0.5 } = {}) {
  const start = performance.now();
  const getTargets = () => [...new Set(selectors.flatMap((sel) => [...document.querySelectorAll(sel)]))];

  let stableCount = 0;
  const lastSize = new WeakMap();
  let resolvePromise,
    stopped = false;

  function inImmediateZone(el) {
    const r = el.getBoundingClientRect();
    const vH = innerHeight || document.documentElement.clientHeight;
    const topBound = -vH * immediateMargin;
    const bottomBound = vH * (1 + immediateMargin);
    return r.bottom >= topBound && r.top <= bottomBound;
  }

  function almostEqual(a, b, t) {
    return Math.abs(a - b) <= t;
  }
  function isStable(el) {
    const rect = el.getBoundingClientRect();
    const prev = lastSize.get(el);
    const cur = { w: rect.width, h: rect.height };
    lastSize.set(el, cur);
    return cur.w > 0 && cur.h > 0 && prev && almostEqual(cur.w, prev.w, eps) && almostEqual(cur.h, prev.h, eps);
  }

  function check() {
    if (stopped) return;
    const els = getTargets();
    if (els.length === 0) return requestAnimationFrame(check);

    if (els.some(inImmediateZone)) {
      stopped = true;
      return resolvePromise({ fastPath: true });
    }

    const allStable = els.every(isStable);
    stableCount = allStable ? stableCount + 1 : 0;

    if (stableCount >= consecutive || performance.now() - start > timeout) {
      stopped = true;
      resolvePromise({ fastPath: false });
    } else {
      requestAnimationFrame(check);
    }
  }

  const startCheck = () => requestAnimationFrame(check);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startCheck, { once: true });
  } else {
    startCheck();
  }

  return new Promise((res) => {
    resolvePromise = res;
  });
}

waitForStableLayout({
  selectors: [".dl-js-sa", ".dl-js-saImage", ".splide"],
  consecutive: 10,
}).then(() => {
  window.DL_ScrollActionInstance = new DL_ScrollAction(".dl-js-sa");
  window.DL_ScrollActionImageInstance = new DL_ScrollActionImage(".dl-js-saImage");
});

// ************************************** セクションチェック
class DL_SectionFunc {
  constructor(selector) {
    this.elements = document.querySelectorAll(selector);
    if (this.elements.length === 0) {
      return;
    } else {
      this.flg = false;
      this.SectionIndex = 0;
      this.SectionIndexAfter = 0;

      this.SectionTopIndex = 0;
      this.SectionTopIndexAfter = 0;
      this.array = [];
      this.border = window.innerHeight * 0.5;
      this.onScrollHandler = this.onScroll.bind(this);

      this.Header = document.querySelector("header");
      this.HeaderHeight = this.Header.offsetHeight;
      window.addEventListener("scroll", this.onScrollHandler, false);
      window.addEventListener("resize", this.onResize.bind(this));
      DL_removeClass(this.elements, "is-active");
      this.init();
    }
  }
  init() {
    this.elements.forEach((element) => {
      this.array.push(DL_offsetTop(element));
    });

    this.onScroll();
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.elements.forEach((element, index) => {
      if (scrollTop + this.border >= this.array[index]) {
        this.SectionIndex = index;
      }
      if (scrollTop + this.HeaderHeight >= this.array[index]) {
        this.SectionTopIndex = index;
      }
    });
    if (this.SectionIndexAfter != this.SectionIndex) {
      DL_removeClass(this.elements, "is-active");
      DL_addClass(this.elements[this.SectionIndex], "is-active");
      if (DL_hasClass(this.elements[this.SectionIndex], "is-invert")) {
        DL_addClass(document.body, "is-invert");
      } else {
        DL_removeClass(document.body, "is-invert");
      }

      if (DL_hasClass(this.elements[this.SectionIndex], "is-wh")) {
        DL_addClass(document.body, "is-wh");
      } else {
        DL_removeClass(document.body, "is-wh");
      }

      if (DL_hasClass(this.elements[this.SectionIndex], "is-transparent")) {
        DL_addClass(document.body, "is-transparent");
      } else {
        DL_removeClass(document.body, "is-transparent");
      }
    }

    this.SectionIndexAfter = this.SectionIndex;

    if (this.SectionTopIndexAfter != this.SectionTopIndex) {
      DL_removeClass(this.elements, "is-sectiontop");
      DL_addClass(this.elements[this.SectionTopIndex], "is-sectiontop");
    }

    this.SectionTopIndexAfter = this.SectionTopIndex;
  }
  onResize() {
    onWidthResize(({ width, height }) => {
      this.init();
    });
  }
}

new DL_SectionFunc("section");

//  20256月追加 START
// ************************************** 背景追従
class DL_BgAdjuster extends HTMLElement {
  constructor() {
    super();
    this.adjustWrap = this.adjustWrap.bind(this);
  }
  connectedCallback() {
    this.bgWrap = this.querySelector(".dl-js-adjustBg__wrap");
    this.bgInner = this.querySelector(".dl-js-adjustBg__inner");
    if (!this.bgWrap || !this.bgInner) return;
    const ratioAttr = this.getAttribute("data-ratio");
    this.innerRatio = ratioAttr ? parseFloat(ratioAttr) : 16 / 9;
    window.addEventListener("load", this.adjustWrap);
    window.addEventListener("resize", this.adjustWrap);
    this.adjustWrap();
  }

  disconnectedCallback() {
    window.removeEventListener("load", this.adjustWrap);
    window.removeEventListener("resize", this.adjustWrap);
  }

  adjustWrap() {
    const parentWidth = this.bgWrap.offsetWidth;
    const parentHeight = this.bgWrap.offsetHeight;
    const innerRatio = this.innerRatio;

    let width = parentWidth;
    let height = width / innerRatio;

    if (height < parentHeight) {
      height = parentHeight;
      width = height * innerRatio;
    }

    this.bgInner.style.width = `${width}px`;
    this.bgInner.style.height = `${height}px`;
  }
}
if (!customElements.get("dl-bg-adjuster")) {
  customElements.define("dl-bg-adjuster", DL_BgAdjuster);
}

// ************************************** 画像上の文字色を反転
class PartsInvert {
  constructor(element) {
    this.element = element;
    this.event();
  }

  event() {
    window.addEventListener("scroll", this.onScroll.bind(this));
    window.addEventListener("resize", this.onResize.bind(this));
    this.update();
  }

  update() {
    this.areas = document.querySelectorAll(".js-partsInvert__area");
    this.onScroll();
  }

  onScroll() {
    const rect = this.element.getBoundingClientRect();
    const elementCenter = rect.top + rect.height / 2;

    let isInAnyArea = false;

    this.areas.forEach((area) => {
      const areaRect = area.getBoundingClientRect();
      if (elementCenter >= areaRect.top && elementCenter <= areaRect.bottom) {
        isInAnyArea = true;
      }
    });

    this.element.classList.toggle("is-invert", isInAnyArea);
  }

  onResize() {
    onWidthResize(({ width, height }) => {
      this.update();
    });
  }
}
document.querySelectorAll(".js-partsInvert").forEach((el) => {
  new PartsInvert(el);
});

// ************************************** 動画
class DL_LazyVideo extends HTMLElement {
  constructor() {
    super();
    this.video = null;
    this.observer = null;
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.video = this.querySelector("video");
    if (!this.video) {
      console.error("DL_LazyVideo: <video> element is missing inside <lazy-video>.");
      return;
    }
    const src = this.video.getAttribute("data-src");
    if (!src) {
      console.error("DL_LazyVideo: data-src attribute is missing on <video>.");
      return;
    }
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.video.src = src;
          this.video.play();
          this.observer.unobserve(this.video);
        }
      });
    });
    this.observer.observe(this.video);
  }

  disconnectedCallback() {
    if (this.observer && this.video) {
      this.observer.unobserve(this.video);
    }
  }
}
if (!customElements.get("dl-lazy-video")) {
  customElements.define("dl-lazy-video", DL_LazyVideo);
}

// ************************************** サブナビ追従
class DlScrollContents extends HTMLElement {
  constructor() {
    super();
    this.sections = [];
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    // this.subnav = document.querySelector(".js-subnavAdjust");
    // this.subnav.classList.add("is-hide");
    this.scrollDisplay = document.querySelector(".js-scrollAdjust");
  }

  connectedCallback() {
    this.wrap = this.querySelector(".dl-js-scrollContents__wrap");
    this.sections = Array.from(this.querySelectorAll(".dl-js-scrollContents__section"));

    if (!this.wrap || this.sections.length === 0) return;

    window.addEventListener("scroll", this.onScroll, {
      passive: true,
    });
    window.addEventListener("resize", this.onResize);

    this.onScroll(); // 初期化
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  }

  onScroll() {
    const viewportCenter = window.innerHeight / 2;
    let closestIndex = 0;
    let closestDistance = Infinity;

    this.sections.forEach((section, index) => {
      const rect = section.getBoundingClientRect();
      const sectionCenter = rect.top + rect.height / 2;
      const distance = Math.abs(viewportCenter - sectionCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    // data-indexを更新
    if (parseInt(this.dataset.index) !== closestIndex) {
      this.dataset.index = closestIndex;
      // if (this.dataset.index == 0) {
      //   this.subnav.classList.add("is-hide");
      //   this.scrollDisplay.classList.remove("is-hide");
      // } else {
      //   this.subnav.classList.remove("is-hide");
      //   this.scrollDisplay.classList.add("is-hide");
      // }
    }

    // is-currentクラスの付け外し
    this.sections.forEach((section, index) => {
      if (index === closestIndex) {
        section.classList.add("is-current");
      } else {
        section.classList.remove("is-current");
      }
    });
  }

  onResize() {
    onWidthResize(({ width, height }) => {
      this.onScroll();
    });
  }
}
if (!customElements.get("dl-scroll-contents")) {
  customElements.define("dl-scroll-contents", DlScrollContents);
}

// ************************************** アンカーリンク

class setAnchor {
  constructor(elements) {
    this.elements = elements;
    this.array = [];
    this.Header = document.querySelector("header");
    this.HeaderHeight = this.Header.offsetHeight;
    // this.adjust = this.HeaderHeight + 40;
    this.elements.forEach((element) => {
      const href = element.getAttribute("href");
      if (!href || !href.includes("#")) return;

      element.targetId = href.split("#")[1];
      element.targetElement = document.getElementById(element.targetId);
      if (!element.targetElement) return;

      element.targetPos = 0;
      this.array.push(element);
    });
    this.event();
  }

  event() {
    this.array.forEach((element) => {
      element.addEventListener("click", (e) => {
        if (element.targetElement) {
          e.preventDefault();

          this.adjust = this.HeaderHeight + 40;
          if (DL_hasClass(this.Header, "is-transparent")) {
            this.adjust = 0;
          }

          element.targetPos = DL_offsetTop(element.targetElement) - this.adjust;
          this.move(element.targetPos, 800, () => {
            this.end();
          });
        }
      });
    });
  }

  move(endY, duration, callback) {
    const startY = window.scrollY || window.pageYOffset;
    const distanceY = endY - startY;
    let startTime = null;

    function scroll(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const newY = DL_easeInOutQuad(timeElapsed, startY, distanceY, duration);
      window.scrollTo(0, newY);
      if (timeElapsed < duration) {
        requestAnimationFrame(scroll);
      } else {
        window.scrollTo(0, endY);
        if (callback) callback();
      }
    }
    requestAnimationFrame(scroll);
  }

  end() {}
}

// イージング関数（DL_easeInOutQuad）
function DL_easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
}

// 初期化処理
document.addEventListener("DOMContentLoaded", () => {
  const anchors = document.querySelectorAll('[href^="#"]:not([href="#"])');
  if (anchors.length > 0) {
    const anchorLink = new setAnchor(anchors);
    if (typeof instanceArray !== "undefined") {
      instanceArray.push(anchorLink);
    }
  }
});
//  20256月追加 END

///////////////////////////////////////////////////
// utility function
///////////////////////////////////////////////////

function DL_media() {
  let media = "PC";
  if (window.innerWidth > 1000) {
    media = "PC";
  } else if (window.innerWidth > 680) {
    media = "TB";
  } else {
    media = "SP";
  }
  return media;
}
window.DL_media = DL_media;

function DL_hasClass(_target, _class) {
  return _target.classList.contains(_class);
}
window.DL_hasClass = DL_hasClass;

function DL_addClass(_target, _class) {
  if (!_target) return;
  if (_target.length) {
    if (Array.isArray(_class)) {
      for (var i = 0; i < _target.length; i++) {
        for (var j = 0; j < _class.length; j++) {
          _target[i].classList.add(_class[j]);
        }
      }
    } else {
      for (var i = 0; i < _target.length; i++) {
        _target[i].classList.add(_class);
      }
    }
  } else {
    if (Array.isArray(_class)) {
      for (var i = 0; i < _class.length; i++) {
        _target.classList.add(_class[i]);
      }
    } else {
      _target.classList.add(_class);
    }
  }
}
window.DL_addClass = DL_addClass;

function DL_removeClass(_target, _class) {
  if (_target.length) {
    if (Array.isArray(_class)) {
      for (var i = 0; i < _target.length; i++) {
        for (var j = 0; j < _class.length; j++) {
          _target[i].classList.remove(_class[j]);
        }
      }
    } else {
      for (var i = 0; i < _target.length; i++) {
        _target[i].classList.remove(_class);
      }
    }
  } else {
    if (Array.isArray(_class)) {
      for (var i = 0; i < _class.length; i++) {
        _target.classList.remove(_class[i]);
      }
    } else {
      _target.classList.remove(_class);
    }
  }
}
window.DL_removeClass = DL_removeClass;

function DL_offsetTop(_target) {
  var rect = _target.getBoundingClientRect();
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return rect.top + scrollTop;
}
window.DL_offsetTop = DL_offsetTop;

function DL_offsetLeft(_target) {
  var rect = _target.getBoundingClientRect();
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  return rect.left + scrollLeft;
}
window.DL_offsetLeft = DL_offsetLeft;

function DL_fadeIn(_target, _time, _callback) {
  _target.style.display = "block";
  _target.style.opacity = 0;

  var start = performance.now();
  if (!_time) {
    _time = 500;
  }
  requestAnimationFrame(function tick(timestamp) {
    var easing = (timestamp - start) / _time;
    _target.style.opacity = Math.min(easing, 1);
    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      if (_callback) {
        _callback();
      }
    }
  });
}
window.DL_fadeIn = DL_fadeIn;

function DL_fadeOut(_target, _time, _callback) {
  var start = performance.now();
  if (!_time) {
    _time = 500;
  }
  requestAnimationFrame(function tick(timestamp) {
    var easing = (timestamp - start) / _time;
    _target.style.opacity = Math.max(1 - easing, 0);
    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      _target.style.opacity = 0;
      _target.style.display = "none";
      if (_callback) {
        _callback();
      }
    }
  });
}
window.DL_fadeOut = DL_fadeOut;

function DL_slideDown(element, duration = 300) {
  element.style.display = "block";
  element.style.overflow = "hidden";
  element.style.height = "0";

  let totalHeight = 0;
  let startTime = null;

  function animate(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = timestamp - startTime;

    totalHeight = (progress / duration) * element.scrollHeight;
    element.style.height = totalHeight + "px";

    if (progress < duration) {
      requestAnimationFrame(animate);
    } else {
      element.style.height = "auto";
      DL_selfResize();
    }
  }

  requestAnimationFrame(animate);
}
window.DL_slideDown = DL_slideDown;

function DL_slideUp(element, duration = 300) {
  let totalHeight = element.scrollHeight;
  let startTime = null;

  function animate(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = timestamp - startTime;

    totalHeight = (1 - progress / duration) * element.scrollHeight;
    element.style.height = totalHeight + "px";

    if (progress < duration) {
      requestAnimationFrame(animate);
    } else {
      element.style.display = "none";
      element.style.overflow = "";
      element.style.height = "";
      DL_selfResize();
    }
  }

  requestAnimationFrame(animate);
}
window.DL_slideUp = DL_slideUp;

function DL_alpha1(_target, _time, _callback) {
  // _target.style.display = "block";
  _target.style.opacity = 0;

  var start = performance.now();
  if (!_time) {
    _time = 500;
  }
  requestAnimationFrame(function tick(timestamp) {
    var easing = (timestamp - start) / _time;
    _target.style.opacity = Math.min(easing, 1);
    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      if (_callback) {
        _callback();
      }
    }
  });
}
window.DL_alpha1 = DL_alpha1;

function DL_alpha0(_target, _time, _callback) {
  var start = performance.now();
  if (!_time) {
    _time = 500;
  }
  requestAnimationFrame(function tick(timestamp) {
    var easing = (timestamp - start) / _time;
    _target.style.opacity = Math.max(1 - easing, 0);
    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      _target.style.opacity = 0;
      // _target.style.display = "none";
      if (_callback) {
        _callback();
      }
    }
  });
}
window.DL_alpha0 = DL_alpha0;

// ゼロパッデング　NUM=値 LEN=桁数
function DL_zeroPadding(NUM, LEN) {
  return (Array(LEN).join("0") + NUM).slice(-LEN);
}
window.DL_zeroPadding = DL_zeroPadding;

function DL_selfResize() {
  var resizeEvent = window.document.createEvent("UIEvents");
  resizeEvent.initUIEvent("resize", true, false, window, 0);
  window.dispatchEvent(resizeEvent);
}
window.DL_selfResize = DL_selfResize;

/**
 * 幅の変化のみを検知する resize イベントリスナー
 * @param {Function} callback - 幅が変化した時に呼ばれる関数
 */
function onWidthResize(callback) {
  let lastWidth = window.innerWidth;

  window.addEventListener("resize", () => {
    const currentWidth = window.innerWidth;

    // PC判定: 例として 1024px 以上をPCとする
    const isPC = currentWidth >= 1024;

    if (isPC) {
      // PCの場合は通常のresizeを全部通す
      callback({ width: currentWidth, height: window.innerHeight });
    } else {
      // スマホ等は幅が変わったときのみ
      if (currentWidth !== lastWidth) {
        callback({ width: currentWidth, height: window.innerHeight });
      }
    }

    lastWidth = currentWidth;
  });
}

// Cookieを設定する
function DL_setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Cookieを取得する
function DL_getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Cookieを削除する
function DL_eraseCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

// DL_selfResize();

// class DL_ScrollAction extends HTMLElement {
//   constructor() {
//     super();
//     this.borderTop = 0;
//     this.borderMiddle = 0.5;
//     this.borderBottom = 1;
//     this.windowTop = window.innerHeight * this.borderTop;
//     this.windowMiddle = window.innerHeight * this.borderMiddle;
//     this.windowBottom = window.innerHeight * this.borderBottom;
//     this.flg = false;
//     this.remove = true; //trueで毎回
//     DL_removeClass(this, "sa-active");
//     this.onScrollHandler = this.onScroll.bind(this);
//     window.addEventListener('scroll', this.onScrollHandler, false);
//     window.addEventListener('resize', this.onResize.bind(this));
//     this.init();
//     this.onScroll();
//   }
//   init() {
//     this.top = DL_offsetTop(this);
//     this.height = this.offsetHeight;
//     this.topHeight = this.top + this.height;
//     this.bottom = this.top + this.height;
//     this.progress = 0;
//     this.flg = false;
//   }
//   onScroll() {
//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//     this.areaTop = Math.floor(scrollTop + this.windowTop);
//     this.areaMiddle = Math.floor(scrollTop + this.windowMiddle);
//     this.areaBottom = Math.floor(scrollTop + this.windowBottom);
//     this.areaHeight = this.areaBottom - this.areaTop;
//     this.areaHalf = this.areaBottom - this.areaMiddle;
//     if (this.areaBottom >= this.top && this.areaTop <= this.bottom) {
//       DL_addClass(this, "sa-active");
//       this.progress = Math.round(((this.areaBottom - this.top) / (this.areaHeight + this.height)) * 100);
//       this.progressHalf = Math.round(((this.areaBottom - this.top) / (this.areaHalf + this.height / 2)) * 100);
//       if (DL_hasClass(this, "dl-js-sa__image")) {
//         var scale = this.getAttribute("data-scale");
//         var range = scale * 100 - 100;
//         this.style.transform = "translate3d(0px, " + (range / 2 - range * (this.progress / 100)) + "%, 0px) scale(" + scale + ")";
//       }
//       if (DL_hasClass(this, "dl-js-sa__float")) {
//         var rangeY = this.getAttribute("data-rangeY");
//         var rangeX = this.getAttribute("data-rangeX");
//         var adjust = Math.round(Math.cos((this.progressHalf * Math.PI) / 180) * 100) / 100;
//         var stop = JSON.parse(this.getAttribute("data-stop").toLowerCase());
//         if (stop) {
//           this.style.transform = "translate3d(" + Math.round(rangeX * Math.max(0, adjust) * 100) / 100 + "%, " + Math.round(rangeY * Math.max(0, adjust) * 100) / 100 + "%, 0px)";
//         } else {
//           this.style.transform = "translate3d(" + Math.round(rangeX * adjust * 100) / 100 + "%, " + Math.round(rangeY * adjust * 100) / 100 + "%, 0px)";
//         }
//       }
//     } else {
//       if (this.remove) {
//         DL_removeClass(this, "sa-active");
//       }
//     }
//   }
//   onResize() {
//     this.init();
//   }
// }
// customElements.define('dl-js-sa', DL_ScrollAction);
// function DL_addClass(_target, _class) {
//   if (_target.length) {
//     if (Array.isArray(_class)) {
//       for (var i = 0; i < _target.length; i++) {
//         for (var j = 0; j < _class.length; j++) {
//           _target[i].classList.add(_class[j]);
//         }
//       }
//     } else {
//       for (var i = 0; i < _target.length; i++) {
//         _target[i].classList.add(_class);
//       }
//     }
//   } else {
//     if (Array.isArray(_class)) {
//       for (var i = 0; i < _class.length; i++) {
//         _target.classList.add(_class[i]);
//       }
//     } else {
//       _target.classList.add(_class);
//     }
//   }
// }

// window.DL_addClass = DL_addClass;

// let Body, Root, Header, Footer, Main, Section;
// let Media = "PC";
// const TB = 1000;
// const SP = 680;
// let LoadFlg = false;
// let CoverFlg = false;
// window.addEventListener("load", function () {
//   addClass(document.body, "is-load");

//   if (!getCookie("visited")) {
//     CoverFlg = true;
//     setCookie("visited", true, 1);
//   } else {
//     CoverFlg = false;
//   }

//   InitFunc.Load();
// });

// const InitFunc = {};
// InitFunc.Load = function () {
//   Body = document.body;
//   Root = document.querySelector(":root");
//   Header = document.querySelector("header");
//   Footer = document.querySelector("footer");
//   Main = document.querySelector(".dl-kinto__top");
//   Section = document.querySelectorAll(".dl-kinto__top section");

//   //LazyBgi
//   if (document.getElementsByClassName("dl-js-lazy_bgi").length) {
//     var lazy_bgi = document.querySelectorAll(".dl-js-lazy_bgi");
//     for (var i = 0; i < lazy_bgi.length; i++) {
//       var bgi = lazy_bgi[i].getAttribute("data-bgi");
//       lazy_bgi[i].style.backgroundImage = "url( " + bgi + " )";
//     }
//   }
//   InitFunc.Set();
//   // addClass(Body, "is-load")
//   LoadFlg = true;
// };
// InitFunc.Set = function () {
//   //DataSet
//   Window.h = window.innerHeight;
//   // Window.h = document.documentElement.clientHeight;
//   Window.w = window.innerWidth;
//   // Header.h = Header.offsetHeight;
//   // Header.w = Header.offsetWidth;
//   // Footer.h = Footer.offsetHeight;
//   // Footer.w = Footer.offsetWidth;
//   // Root.style.setProperty('--HeaderHeight', Header.h + 'px');
//   // alert(Window.h)
//   if (Window.w > TB) {
//     Media = "PC";
//   } else if (Window.w > SP) {
//     Media = "TB";
//   } else {
//     Media = "SP";
//   }
// };

// // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// // [Usefull] ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// function hasClass(_target, _class) {
//   return _target.classList.contains(_class);
// }

// function addClass(_target, _class) {
//   if (_target.length) {
//     if (Array.isArray(_class)) {
//       for (var i = 0; i < _target.length; i++) {
//         for (var j = 0; j < _class.length; j++) {
//           _target[i].classList.add(_class[j]);
//         }
//       }
//     } else {
//       for (var i = 0; i < _target.length; i++) {
//         _target[i].classList.add(_class);
//       }
//     }
//   } else {
//     if (Array.isArray(_class)) {
//       for (var i = 0; i < _class.length; i++) {
//         _target.classList.add(_class[i]);
//       }
//     } else {
//       _target.classList.add(_class);
//     }
//   }
// }

// function removeClass(_target, _class) {
//   if (_target.length) {
//     if (Array.isArray(_class)) {
//       for (var i = 0; i < _target.length; i++) {
//         for (var j = 0; j < _class.length; j++) {
//           _target[i].classList.remove(_class[j]);
//         }
//       }
//     } else {
//       for (var i = 0; i < _target.length; i++) {
//         _target[i].classList.remove(_class);
//       }
//     }
//   } else {
//     if (Array.isArray(_class)) {
//       for (var i = 0; i < _class.length; i++) {
//         _target.classList.remove(_class[i]);
//       }
//     } else {
//       _target.classList.remove(_class);
//     }
//   }
// }

// function offsetTop(_target) {
//   var rect = _target.getBoundingClientRect();
//   var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//   return rect.top + scrollTop;
// }

// function offsetLeft(_target) {
//   var rect = _target.getBoundingClientRect();
//   var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
//   return rect.left + scrollLeft;
// }

// function fadeIn(_target, _time, _callback) {
//   _target.style.display = "block";
//   _target.style.opacity = 0;

//   var start = performance.now();
//   if (!_time) {
//     _time = 500;
//   }
//   requestAnimationFrame(function tick(timestamp) {
//     var easing = (timestamp - start) / _time;
//     _target.style.opacity = Math.min(easing, 1);
//     if (easing < 1) {
//       requestAnimationFrame(tick);
//     } else {
//       if (_callback) {
//         _callback();
//       }
//     }
//   });
// }

// function fadeOut(_target, _time, _callback) {
//   var start = performance.now();
//   if (!_time) {
//     _time = 500;
//   }
//   requestAnimationFrame(function tick(timestamp) {
//     var easing = (timestamp - start) / _time;
//     _target.style.opacity = Math.max(1 - easing, 0);
//     if (easing < 1) {
//       requestAnimationFrame(tick);
//     } else {
//       _target.style.opacity = 0;
//       _target.style.display = "none";
//       if (_callback) {
//         _callback();
//       }
//     }
//   });
// }

// function slideUp(_target, _time, _callback) {
//   var start = performance.now();
//   var height = _target.getAttribute("data-height");
//   if (!_time) {
//     _time = 500;
//   }
//   requestAnimationFrame(function tick(timestamp) {
//     var easing = (timestamp - start) / _time;
//     _target.style.height = Math.max(1 - easing, 0) * height + "px";
//     if (easing < 1) {
//       requestAnimationFrame(tick);
//     } else {
//       _target.style.height = 0;
//       _target.style.display = "none";
//       if (_callback) {
//         _callback();
//       }
//     }
//   });
// }

// function slideDown(_target, _time, _callback) {
//   _target.style.display = "block";
//   _target.style.height = 0;
//   var start = performance.now();
//   var height = _target.getAttribute("data-height");

//   if (!_time) {
//     _time = 500;
//   }
//   requestAnimationFrame(function tick(timestamp) {
//     var easing = (timestamp - start) / _time;
//     _target.style.height = Math.min(easing, 1) * height + "px";
//     if (easing < 1) {
//       requestAnimationFrame(tick);
//     } else {
//       _target.style.height = height + "px";
//       _target.style.display = "block";
//       if (_callback) {
//         _callback();
//       }
//     }
//   });
// }

// function tile(_target, _num) {
//   if (!_num) {
//     var array = [];
//     for (var i = 0; i < _target.length; i++) {
//       _target[i].style.height = "auto";
//       array.push(_target[i].offsetHeight);
//     }
//     var max = Math.max.apply(null, array);
//     for (var i = 0; i < _target.length; i++) {
//       _target[i].style.height = max + "px";
//     }
//   } else {
//     var array = [];
//     var arrayIn = [];
//     var maxArray = [];
//     var idx = 0;
//     for (var i = 0; i < _target.length; i++) {
//       if (i % _num == 0) {
//         arrayIn = [];
//         array.push(arrayIn);
//       }
//       _target[i].style.height = "auto";
//       arrayIn.push(_target[i].offsetHeight);
//     }

//     for (var i = 0; i < array.length; i++) {
//       maxArray.push(Math.max.apply(null, array[i]));
//     }

//     for (var i = 0; i < _target.length; i++) {
//       if (i % _num == 0) {
//         var max = maxArray[i / _num];
//       }
//       _target[i].style.height = max + "px";
//     }
//   }
// }

// // ゼロパッデング　NUM=値 LEN=桁数
// function zeroPadding(NUM, LEN) {
//   return (Array(LEN).join("0") + NUM).slice(-LEN);
// }

// // Cookieに初回訪問フラグをセットする
// function setCookie(name, value, days) {
//   var expires = "";
//   if (days) {
//     var date = new Date();
//     date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
//     expires = "; expires=" + date.toUTCString();
//   }
//   document.cookie = name + "=" + (value || "") + expires + "; path=/";
// }

// // Cookieから初回訪問フラグを取得する
// function getCookie(name) {
//   var nameEQ = name + "=";
//   var ca = document.cookie.split(";");
//   for (var i = 0; i < ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) == " ") c = c.substring(1, c.length);
//     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
//   }
//   return null;
// }

// // cookieを削除する関数
// function deleteCookie(name) {
//   document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
// }

// [JournalMapFunc] ************************************************************
let JournalMapFunc = {};

// アイコン色設定
JournalMapFunc.iconColors = {
  normal: { stroke: "#000000", fill: "#ffffff" },
  active: { stroke: null, fill: null }, // 初期化時にCSS変数から取得
};

// CSS変数からアクセント色を取得
JournalMapFunc.getAccentColor = function () {
  var accent = getComputedStyle(document.documentElement).getPropertyValue("--Accent").trim();
  return accent || "#e74c3c"; // フォールバック: 赤系
};

// アクティブアイコンのURLを生成（_activeサフィックス）
JournalMapFunc.getActiveIconUrl = function (normalUrl) {
  if (!normalUrl || typeof normalUrl !== "string") return normalUrl;
  // .svg の前に _active を挿入（dl-プレフィックスは保持）
  // 例: /assets/dl-journal_map_icon_shops.svg -> /assets/dl-journal_map_icon_shops_active.svg
  return normalUrl.replace(/\.svg$/i, "_active.svg");
};

// 参考サイト風のマップスタイル（落ち着いた色調、青い水域）
JournalMapFunc.style = [
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#a8d4e6" }],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{ color: "#ffffff" }],
  },
  // 高速道路（濃いブルーグレー）
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [{ color: "#9aacb8" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#8599a6" }],
  },
  // 幹線道路・主要道路（ブルーグレー）
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ color: "#c5d1d8" }],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.stroke",
    stylers: [{ color: "#a8b8c2" }],
  },
  // 細かい道路（薄いグレー・目立たない色）
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{ color: "#f0f0f0" }],
  },
  {
    featureType: "road.local",
    elementType: "geometry.stroke",
    stylers: [{ color: "#e5e5e5" }],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{ color: "#e8f5e9" }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#c8e6c9" }],
  },
  {
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [{ color: "#666666" }],
  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#ffffff" }, { weight: 2 }],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#e0e0e0" }],
  },
  // POI（店舗・施設アイコン）を非表示
  {
    featureType: "poi",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text",
    stylers: [{ visibility: "off" }],
  },
  // ビジネス（店舗）アイコンを非表示
  {
    featureType: "poi.business",
    stylers: [{ visibility: "off" }],
  },
  // 交通機関アイコンを非表示（必要に応じて）
  {
    featureType: "transit.station",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
];
JournalMapFunc.maps = [];
JournalMapFunc.Init = function () {
  if (!window.journalMapData) return;

  // アコーディオン初期化
  JournalMapFunc.initAccordion();

  window.journalMapData.forEach(function (mapData) {
    var container = document.getElementById(mapData.id);
    if (!container) return;

    var wrap = container.querySelector(".dl-js-journal-map__wrap");
    if (!wrap) return;

    var pins = mapData.pins;
    if (!pins || pins.length === 0) return;

    var bounds = new google.maps.LatLngBounds();
    var hasInitialBounds = false;
    pins.forEach(function (pin) {
      if (pin.lat && pin.lng) {
        bounds.extend(new google.maps.LatLng(pin.lat, pin.lng));
        hasInitialBounds = true;
      }
    });

    // lat/lngがない場合は東京をデフォルトの中心に
    var center = hasInitialBounds ? bounds.getCenter() : new google.maps.LatLng(35.6812, 139.7671);

    var map = new google.maps.Map(wrap, {
      center: center,
      zoom: hasInitialBounds ? 13 : 12,
      panControl: false,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      clickableIcons: false, // デフォルトPOIのクリックを無効化
    });
    map.setOptions({ styles: JournalMapFunc.style });
    if (hasInitialBounds) {
      map.fitBounds(bounds);
      // サイドバー分のオフセットを適用（PC時）
      google.maps.event.addListenerOnce(map, "idle", function () {
        JournalMapFunc.applySidebarOffset(map);
      });
    }

    var infoWindowMaxWidth = window.innerWidth <= 480 ? 260 : window.innerWidth <= 768 ? 280 : 320;
    var infoWindow = new google.maps.InfoWindow({
      maxWidth: infoWindowMaxWidth,
      disableAutoPan: true, // 自動パンを無効化（smoothPanToで位置調整済み）
    });
    var markers = [];
    var placesService = new google.maps.places.PlacesService(map);
    var currentMarkerIndex = -1; // 現在選択中のマーカーインデックス

    // マーカー作成用の共通関数
    function createMarker(pin, index, position) {
      var marker = new google.maps.Marker({
        position: position,
        map: map,
        title: pin.title,
      });

      // カスタムSVGアイコン対応（文字列またはオブジェクト形式に対応）
      if (pin.icon) {
        var iconConfig = typeof pin.icon === "string" ? { url: pin.icon, width: 48, height: 48 } : pin.icon;

        if (iconConfig.url) {
          // SVGの場合はアクティブ用URLを生成
          if (iconConfig.url.endsWith(".svg")) {
            pin._iconNormal = iconConfig.url;
            pin._iconActive = JournalMapFunc.getActiveIconUrl(iconConfig.url);
            pin._iconConfig = iconConfig;
          }

          // アイコンを設定
          marker.setIcon({
            url: iconConfig.url,
            scaledSize: new google.maps.Size(iconConfig.width || 48, iconConfig.height || 48),
            anchor: new google.maps.Point(iconConfig.anchorX || (iconConfig.width ? iconConfig.width / 2 : 24), iconConfig.anchorY || iconConfig.height || 48),
          });
        }
      }

      marker.pinData = pin;
      marker.pinIndex = index;
      markers[index] = marker;

      marker.addListener("click", function () {
        // 同じマーカーをクリックした場合は移動しない
        if (currentMarkerIndex === index) {
          return;
        }
        currentMarkerIndex = index;
        // サイドバーと同じ挙動：マップ中央に移動
        JournalMapFunc.smoothPanTo(map, marker.getPosition());
        JournalMapFunc.openInfoWindow(map, infoWindow, marker);
        JournalMapFunc.highlightListItem(mapData.id, index);
      });

      // boundsを更新
      bounds.extend(position);
      map.fitBounds(bounds);
    }

    pins.forEach(function (pin, index) {
      // lat/lngがある場合は直接マーカー作成
      if (pin.lat && pin.lng) {
        var position = new google.maps.LatLng(pin.lat, pin.lng);
        createMarker(pin, index, position);
      }
      // place_idのみの場合はPlaces APIで座標を取得
      else if (pin.place_id) {
        placesService.getDetails({ placeId: pin.place_id, fields: ["geometry", "name"] }, function (place, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK && place && place.geometry) {
            var position = place.geometry.location;
            // 取得した座標をキャッシュ
            pin.lat = position.lat();
            pin.lng = position.lng();
            createMarker(pin, index, position);
          } else {
            console.warn("[JournalMap] Failed to get location for place_id:", pin.place_id, status);
          }
        });
      }
    });

    JournalMapFunc.maps.push({
      id: mapData.id,
      map: map,
      markers: markers,
      infoWindow: infoWindow,
    });

    var listItems = document.querySelectorAll(".dl-js-journal-map-item");
    listItems.forEach(function (item) {
      item.addEventListener("click", function () {
        var itemIndex = parseInt(item.getAttribute("data-index"));
        // 同じ場所をクリックした場合は移動しない
        if (currentMarkerIndex === itemIndex) {
          return;
        }
        var targetMarker = markers[itemIndex];
        if (targetMarker) {
          currentMarkerIndex = itemIndex;
          JournalMapFunc.smoothPanTo(map, targetMarker.getPosition());
          JournalMapFunc.openInfoWindow(map, infoWindow, targetMarker);
          JournalMapFunc.highlightListItem(mapData.id, itemIndex);

          // スマホ時はマップまでスクロール（見切れないように）
          if (window.innerWidth <= 768) {
            setTimeout(function () {
              var headerHeight = 60; // 固定ヘッダーの高さ（必要に応じて調整）
              var containerTop = container.getBoundingClientRect().top + window.pageYOffset;
              var scrollToPosition = containerTop - headerHeight;
              window.scrollTo({ top: scrollToPosition, behavior: "smooth" });
            }, 100);
          }
        }
      });
    });

    // マップの初期化完了後、スクロールアニメーションを再計算
    google.maps.event.addListenerOnce(map, "idle", function () {
      // すべてのマップが初期化完了
      if (window.DL_ScrollActionInstance) {
        window.DL_ScrollActionInstance.init();
      }
      if (window.DL_ScrollActionImageInstance) {
        window.DL_ScrollActionImageInstance.init();
      }
    });
  });

  // マップ初期化完了フラグ
  document.body.dataset.journalMapInited = "1";
};

// サイドバーの幅（PC時のオフセット用）- CSSと同じ値
JournalMapFunc.sidebarWidth = 280;
// InfoWindowカードの高さ（オフセット計算用）
JournalMapFunc.cardHeight = 300;

// サイドバー分のオフセットを適用（初期表示用）
JournalMapFunc.applySidebarOffset = function (map) {
  // モバイル時はオフセットなし
  if (window.innerWidth <= 768) return;

  // サイドバーの半分だけマップを右にずらす
  map.panBy(-JournalMapFunc.sidebarWidth / 2, 0);
};

// マップ移動 - サイドバーとカード高さを考慮し、カード全体が見えるように配置
JournalMapFunc.smoothPanTo = function (map, targetPosition) {
  var isPC = window.innerWidth > 768;
  var isSP = window.innerWidth <= 480; // スマホ（縦積みレイアウト）
  // PC: サイドバーを除いた表示エリアの中央に配置
  // マップ中心からサイドバー幅の半分だけ左にずらした点を中心にする
  // → マーカーはサイドバーを除いた領域の中央に表示される
  // SP: 縦積みレイアウトのためサイドバーオフセット不要
  var sidebarOffsetPx = isPC ? JournalMapFunc.sidebarWidth / 2 : 0;
  // カードがピンの上に表示されるので、カードの高さ分だけ下にオフセット
  // → カードがより画面中央寄りに表示される
  // SP: カードを大きく(360px)表示するため、ピンをマップ下部に配置（オフセット大）
  var cardOffsetPx = isPC ? JournalMapFunc.cardHeight * 0.6 : isSP ? 180 : 80;

  var projection = map.getProjection();
  if (!projection) {
    map.panTo(targetPosition);
    return;
  }

  var scale = Math.pow(2, map.getZoom());
  var targetPoint = projection.fromLatLngToPoint(targetPosition);

  // オフセットを適用した中心点を計算
  // X: 左にずらす → マーカーがサイドバーを除いた領域の中央に
  // Y: 上にずらす → カードが画面下寄りに表示される
  var offsetCenterPoint = new google.maps.Point(targetPoint.x - sidebarOffsetPx / scale, targetPoint.y - cardOffsetPx / scale);

  var offsetCenter = projection.fromPointToLatLng(offsetCenterPoint);
  map.panTo(offsetCenter);
};

JournalMapFunc.openInfoWindow = function (map, infoWindow, marker) {
  var pin = marker.pinData;
  // console.log("[JournalMap] openInfoWindow called", { place_id: pin.place_id, _placeFetched: pin._placeFetched });

  // place_idがある場合はPlaces APIで情報を取得
  if (pin.place_id && !pin._placeFetched) {
    // console.log("[JournalMap] Fetching Places API for:", pin.place_id);

    // Places APIが利用可能か確認
    if (!google.maps.places || !google.maps.places.PlacesService) {
      console.error("[JournalMap] Places API not available. Make sure &libraries=places is in the API script URL.");
      JournalMapFunc.renderInfoWindow(map, infoWindow, marker);
      return;
    }

    var service = new google.maps.places.PlacesService(map);
    service.getDetails(
      {
        placeId: pin.place_id,
        fields: ["name", "photos", "formatted_address", "formatted_phone_number", "website", "url", "opening_hours", "rating", "user_ratings_total", "types"],
      },
      function (place, status) {
        console.log("[JournalMap] Places API response:", { status: status, place: place });
        pin._placeFetched = true;
        if (status === google.maps.places.PlacesServiceStatus.OK && place) {
          // Places APIデータをキャッシュ
          pin._placeName = place.name || null;
          pin._placePhoto = place.photos && place.photos.length > 0 ? place.photos[0].getUrl({ maxWidth: 280 }) : null;
          pin._placeAddress = place.formatted_address || null;
          pin._placePhone = place.formatted_phone_number || null;
          pin._placeWebsite = place.website || null;
          pin._placeUrl = place.url || null;
          pin._placeHours = place.opening_hours ? place.opening_hours.weekday_text : null;
          pin._placeRating = place.rating || null;
          pin._placeRatingsTotal = place.user_ratings_total || null;
          pin._placeTypes = place.types || null; // Googleカテゴリ
          console.log("[JournalMap] Cached data:", { name: pin._placeName, address: pin._placeAddress, rating: pin._placeRating, types: pin._placeTypes });
        } else {
          console.warn("[JournalMap] Places API error:", status);
        }
        JournalMapFunc.renderInfoWindow(map, infoWindow, marker);
      },
    );
    // 読み込み中を表示
    infoWindow.setContent('<div class="dl-js-journal-map__info dl-js-journal-map__info--loading">読み込み中...</div>');
    infoWindow.open(map, marker);
  } else {
    JournalMapFunc.renderInfoWindow(map, infoWindow, marker);
  }
};

// Googleカテゴリの日本語変換マップ
JournalMapFunc.typeLabels = {
  restaurant: "レストラン",
  cafe: "カフェ",
  bar: "バー",
  bakery: "ベーカリー",
  meal_takeaway: "テイクアウト",
  meal_delivery: "デリバリー",
  food: "フード",
  store: "ショップ",
  clothing_store: "衣料品店",
  shoe_store: "靴店",
  jewelry_store: "ジュエリー",
  furniture_store: "家具店",
  home_goods_store: "生活雑貨",
  book_store: "書店",
  florist: "花屋",
  museum: "美術館・博物館",
  art_gallery: "ギャラリー",
  tourist_attraction: "観光スポット",
  park: "公園",
  spa: "スパ",
  beauty_salon: "美容室",
  hair_care: "ヘアサロン",
  gym: "ジム",
  lodging: "宿泊施設",
  hotel: "ホテル",
};
// 表示しない一般的すぎるタイプ
JournalMapFunc.excludeTypes = ["establishment", "point_of_interest", "food", "store"];

JournalMapFunc.renderInfoWindow = function (map, infoWindow, marker) {
  var pin = marker.pinData;
  var spriteBase = window.DL_SPRITE_URL || "";

  // 画像（指定 → Places API）
  var imageUrl = pin.image || pin._placePhoto || null;
  var photoHtml = imageUrl ? '<div class="dl-js-journal-map__info__image" style="background-image: url(' + imageUrl + ')"></div>' : "";

  // 店名（指定 → Places API）
  var shopName = pin.title || pin._placeName || "";

  // featuredフラグ（ハートアイコン）
  var featuredHtml = pin.featured ? '<span class="dl-js-journal-map__info__featured" title="記事で紹介"><svg><use xlink:href="' + spriteBase + 'icon-heart"></use></svg></span>' : "";

  // Googleカテゴリ（Places API）
  var categoryHtml = "";
  if (pin._placeTypes && pin._placeTypes.length > 0) {
    var filteredTypes = pin._placeTypes.filter(function (type) {
      return JournalMapFunc.excludeTypes.indexOf(type) === -1;
    });
    if (filteredTypes.length > 0) {
      var labels = filteredTypes.slice(0, 2).map(function (type) {
        return JournalMapFunc.typeLabels[type] || type.replace(/_/g, " ");
      });
      categoryHtml = '<span class="dl-js-journal-map__info__category">' + labels.join(" / ") + "</span>";
    }
  }

  // 紹介文（指定のみ）
  // var textHtml = pin.text ? '<p class="dl-js-journal-map__info__text">' + pin.text + "</p>" : "";
  var textHtml = "";

  // === BODY部分: 星評価・住所・電話・URL ===
  var bodyHtml = "";
  var footHtml = '<div class="dl-js-journal-map__info__links">';

  // 星評価（Places API）
  if (pin._placeRating) {
    var rating = pin._placeRating;
    var fullStars = Math.floor(rating);
    var halfStar = rating % 1 >= 0.5;
    var starsHtml = '<div class="dl-js-journal-map__info__rating">';
    starsHtml += '<span class="dl-js-journal-map__info__rating__stars">';
    for (var i = 0; i < 5; i++) {
      if (i < fullStars) {
        starsHtml += '<span class="star star--full">★</span>';
      } else if (i === fullStars && halfStar) {
        starsHtml += '<span class="star star--half">★</span>';
      } else {
        starsHtml += '<span class="star star--empty">☆</span>';
      }
    }
    starsHtml += "</span>";
    starsHtml += '<span class="dl-js-journal-map__info__rating__value">' + rating.toFixed(1) + "</span>";
    if (pin._placeRatingsTotal) {
      starsHtml += '<span class="dl-js-journal-map__info__rating__count">(' + pin._placeRatingsTotal + "件)</span>";
    }
    starsHtml += "</div>";
    bodyHtml += starsHtml;
  }

  // 住所（Places API）
  if (pin._placeAddress) {
    bodyHtml += '<p class="dl-js-journal-map__info__address">' + pin._placeAddress + "</p>";
  }

  // 電話番号（Places API）
  if (pin._placePhone) {
    bodyHtml += '<p class="dl-js-journal-map__info__phone"><a href="tel:' + pin._placePhone + '">' + pin._placePhone + "</a></p>";
  }

  // カスタムリンク（PHPで生成したHTML）
  var customLinksHtml = pin.linksHtml || "";

  // Google Maps URL（Places API）
  if (pin._placeUrl) {
    footHtml +=
      '<div class="dl-snippets_link "><a href="' +
      pin._placeUrl +
      '" target="_blank"><svg viewBox="0 0 24 24"><use xlink:href="' +
      spriteBase +
      'icon-map"></use></svg><span>Google Mapsで見る</span></a></div>';
  }

  // ウェブサイト（指定 → Places API）- カスタムリンクに含まれていない場合のみ表示
  var websiteUrl = pin.website || pin._placeWebsite || null;
  if (websiteUrl) {
    // カスタムリンクに同じURLが含まれているかチェック
    var isDuplicate = customLinksHtml && customLinksHtml.indexOf(websiteUrl) !== -1;
    if (!isDuplicate) {
      footHtml +=
        '<div class="dl-snippets_link "><a href="' +
        websiteUrl +
        '" target="_blank"><svg viewBox="0 0 24 24"><use xlink:href="' +
        spriteBase +
        'icon-website"></use></svg><span>公式サイト</span></a></div>';
    }
  }

  if (customLinksHtml) {
    footHtml += customLinksHtml;
  }
  footHtml += "</div>";

  var content =
    '<div class="dl-js-journal-map__info">' +
    photoHtml +
    '<div class="dl-js-journal-map__info__wrap">' +
    '<div class="dl-js-journal-map__info__head">' +
    '<p class="dl-js-journal-map__info__title">' +
    shopName +
    featuredHtml +
    "</p>" +
    categoryHtml +
    textHtml +
    "</div>" +
    '<div class="dl-js-journal-map__info__body">' +
    bodyHtml +
    "</div>" +
    '<div class="dl-js-journal-map__info__foot">' +
    footHtml +
    "</div>" +
    "</div></div>";

  infoWindow.setContent(content);
  infoWindow.open(map, marker);
};

JournalMapFunc.highlightListItem = function (mapId, index) {
  var allItems = document.querySelectorAll(".dl-js-journal-map-item");
  allItems.forEach(function (item) {
    item.classList.remove("is-active");
  });

  var targetItem = document.querySelector('.dl-js-journal-map-item[data-index="' + index + '"]');
  if (targetItem) {
    targetItem.classList.add("is-active");
    // アコーディオンが閉じている場合は開く
    var accordion = targetItem.closest(".dl-journal_article__body__mapApi__accordion");
    if (accordion && !accordion.classList.contains("is-open")) {
      var trigger = accordion.querySelector(".js-map-accordion-trigger");
      if (trigger) trigger.click();
    }
    // ピンタップ時はリストをスクロールしない
    // targetItem.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  // マーカーのハイライト（サイズ変更）
  JournalMapFunc.highlightMarker(mapId, index);
};

// マーカーのハイライト（アクティブなマーカーを大きくし、色を変更する）
JournalMapFunc.highlightMarker = function (mapId, activeIndex) {
  var mapData = JournalMapFunc.maps.find(function (m) {
    return m.id === mapId;
  });
  if (!mapData) return;

  mapData.markers.forEach(function (marker, index) {
    if (!marker) return;
    var pin = marker.pinData;
    var isActive = index === activeIndex;

    // アイコン設定がある場合
    if (pin.icon) {
      var iconConfig = pin._iconConfig || (typeof pin.icon === "string" ? { url: pin.icon, width: 52, height: 52 } : pin.icon);
      var width = isActive ? (iconConfig.width || 52) * 1.5 : iconConfig.width || 52;
      var height = isActive ? (iconConfig.height || 52) * 1.5 : iconConfig.height || 52;

      // SVGの場合は色分けData URIを使用
      var iconUrl;
      if (pin._iconActive && pin._iconNormal) {
        iconUrl = isActive ? pin._iconActive : pin._iconNormal;
      } else {
        iconUrl = iconConfig.url;
      }

      marker.setIcon({
        url: iconUrl,
        scaledSize: new google.maps.Size(width, height),
        anchor: new google.maps.Point(width / 2, height),
      });
    }
    // デフォルトマーカーの場合はzIndexで前面に
    marker.setZIndex(isActive ? 1000 : 1);
  });
};

// アコーディオン初期化
JournalMapFunc.initAccordion = function () {
  var triggers = document.querySelectorAll(".js-map-accordion-trigger");
  triggers.forEach(function (trigger, index) {
    // 最初のアコーディオンは開いた状態にする
    if (index === 0) {
      trigger.closest(".dl-journal_article__body__mapApi__accordion").classList.add("is-open");
    }

    trigger.addEventListener("click", function () {
      var accordion = this.closest(".dl-journal_article__body__mapApi__accordion");
      accordion.classList.toggle("is-open");
    });
  });

  // モバイル用ハンバーガーメニュー初期化
  JournalMapFunc.initHamburger();
};

// モバイル用ハンバーガーメニュー
JournalMapFunc.initHamburger = function () {
  var hamburgers = document.querySelectorAll(".js-map-hamburger");
  hamburgers.forEach(function (hamburger) {
    var container = hamburger.closest(".dl-journal_article__body__mapApi");
    var sidebar = container.querySelector(".js-map-sidebar");
    if (!sidebar) return;

    hamburger.addEventListener("click", function () {
      hamburger.classList.toggle("is-active");
      sidebar.classList.toggle("is-open");
    });

    // サイドバー内のアイテムクリック時にサイドバーを閉じる（モバイル）
    var items = sidebar.querySelectorAll(".dl-js-journal-map-item");
    items.forEach(function (item) {
      item.addEventListener("click", function () {
        if (window.innerWidth <= 768) {
          hamburger.classList.remove("is-active");
          sidebar.classList.remove("is-open");
        }
      });
    });
  });
};

// data要素 → window.journalMapData に変換（Shopify等scriptが使えない環境用）
(function () {
  var dataEls = document.querySelectorAll(".dl-js-journal-map-data");
  if (!dataEls.length) return;
  dataEls.forEach(function (el) {
    try {
      var mapId = el.dataset.mapId;
      window.journalMapData = window.journalMapData || [];
      // 同じIDが既に登録済みならスキップ（scriptタグと重複しない）
      var exists = window.journalMapData.some(function (d) { return d.id === mapId; });
      if (exists) return;
      window.journalMapData.push({
        id: mapId,
        pins: JSON.parse(el.dataset.pins),
      });
      if (el.dataset.spriteUrl && !window.DL_SPRITE_URL) {
        window.DL_SPRITE_URL = el.dataset.spriteUrl;
      }
    } catch (e) {
      console.error("[JournalMap] Failed to parse map data from element", e);
    }
  });
})();

// JournalMapFunc初期化
window.addEventListener("load", function () {
  var mapElements = document.querySelectorAll(".dl-js-journal-map");
  if (mapElements.length && window.journalMapData) {
    if (typeof google !== "undefined" && google.maps) {
      JournalMapFunc.Init();
    } else {
      var checkGoogleMaps = setInterval(function () {
        if (typeof google !== "undefined" && google.maps) {
          clearInterval(checkGoogleMaps);
          JournalMapFunc.Init();
        }
      }, 100);
    }
  }
});
